/* Kalma theme JS — v2
   Carrito lateral AJAX, countdown en tiempo real, animaciones al scroll,
   galería con zoom/lightbox, sticky buy bar en móvil, cart bounce, toast.
   Vanilla JS, sin dependencias. Respeta prefers-reduced-motion. */

(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducedMotion) document.body.classList.add('k-js');

  const moneyEs = (cents) => {
    const val = (cents / 100).toFixed(2);
    const [intPart, dec] = val.split('.');
    const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return intFmt + ',' + dec + ' €';
  };
  const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ── Header sticky con sombra ── */
  const header = $('.k-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Menú móvil ── */
  const hamburger = $('.k-hamburger');
  const mobileMenu = $('.k-mobile-menu');
  const mobileClose = $('.k-mobile-menu__close');
  const openMenu = () => { if (mobileMenu) { mobileMenu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } };
  const closeMenu = () => { if (mobileMenu) { mobileMenu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } };
  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMenu);
  if (mobileMenu) $$('.k-mobile-menu a', mobileMenu).forEach((a) => a.addEventListener('click', closeMenu));

  /* ── FAQ acordeón: cierre con Escape ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.k-faq__item[open]').forEach((el) => el.removeAttribute('open'));
  });

  /* ── Countdown de la oferta ── */
  const countdownEls = $$('[data-countdown-end]');
  if (countdownEls.length && !reducedMotion) {
    const tick = () => {
      const now = Date.now();
      countdownEls.forEach((el) => {
        const end = parseInt(el.dataset.countdownEnd, 10);
        if (!end) return;
        const diff = end - now;
        if (diff <= 0) {
          el.classList.add('is-ended');
          el.innerHTML = '<span class="k-countdown__ended">Oferta terminada</span>';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff / 3600000) % 24);
        const m = Math.floor((diff / 60000) % 60);
        const s = Math.floor((diff / 1000) % 60);
        el.innerHTML =
          '<span class="k-countdown__unit"><b>' + d + '</b><em>días</em></span>' +
          '<span class="k-countdown__unit"><b>' + String(h).padStart(2, '0') + '</b><em>horas</em></span>' +
          '<span class="k-countdown__unit"><b>' + String(m).padStart(2, '0') + '</b><em>min</em></span>' +
          '<span class="k-countdown__unit"><b>' + String(s).padStart(2, '0') + '</b><em>seg</em></span>';
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ── Animaciones al hacer scroll (IntersectionObserver) ── */
  if ('IntersectionObserver' in window && !reducedMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    const els = $$('[data-reveal]');
    // Reveal inmediato de los que ya están en pantalla al cargar
    const vh = window.innerHeight;
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh) el.classList.add('is-visible');
      else io.observe(el);
    });
    // Safety-net: si algo se queda oculto tras 500ms, revelarlo
    setTimeout(() => $$('[data-reveal]:not(.is-visible)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.1) el.classList.add('is-visible');
    }), 500);
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Selector de variantes (buy module) ── */
  const buyForm = $('form[data-buy-form]');
  if (buyForm) {
    const variantInputs = $$('.k-variant input[type="radio"]', buyForm);
    const idInput = $('input[name="id"]', buyForm);
    const priceEl = $('[data-buy-price]');
    const submit = $('button[type="submit"]', buyForm);

    const updateSelection = () => {
      variantInputs.forEach((inp) => {
        const label = inp.closest('.k-variant');
        if (!label) return;
        label.classList.toggle('is-selected', inp.checked);
        if (inp.checked) {
          if (idInput) idInput.value = inp.value;
          const price = parseInt(inp.dataset.price, 10);
          const compare = parseInt(inp.dataset.compareAt, 10);
          const available = inp.dataset.available === 'true';
          if (priceEl && price) {
            let html = '<span class="k-price__now">' + moneyEs(price) + '</span>';
            if (compare && compare > price) {
              const saved = compare - price;
              html += ' <span class="k-price__was">' + moneyEs(compare) + '</span>';
              html += ' <span class="k-price__save">Ahorras ' + moneyEs(saved) + '</span>';
            }
            priceEl.innerHTML = html;
          }
          if (submit) {
            submit.disabled = !available;
            submit.textContent = available ? (submit.dataset.labelAvailable || 'Añadir al carrito') : (submit.dataset.labelSoldOut || 'Agotado');
          }
        }
      });
    };
    variantInputs.forEach((inp) => inp.addEventListener('change', updateSelection));
    updateSelection();

    // Cantidad
    const qtyMinus = $('[data-qty-minus]', buyForm);
    const qtyPlus = $('[data-qty-plus]', buyForm);
    const qtyInput = $('input[name="quantity"]', buyForm);
    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', (e) => { e.preventDefault(); qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', (e) => { e.preventDefault(); qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    // Galería con lightbox
    $$('.k-buy__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('.k-buy__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const main = $('.k-buy__main');
        const src = thumb.dataset.img;
        if (main && src) {
          main.innerHTML = '<img src="' + src + '" alt="" style="opacity:0;transition:opacity .25s;">';
          const img = main.querySelector('img');
          requestAnimationFrame(() => { img.style.opacity = '1'; });
        }
      });
    });

    // AJAX add to cart → toast + drawer
    buyForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submit) { submit.disabled = true; const orig = submit.textContent; submit.dataset.orig = orig; submit.textContent = 'Añadiendo…'; }
      try {
        const formData = new FormData(buyForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (!res.ok) throw new Error('Add to cart failed');
        bounceCart();
        showToast('Añadido al carrito ✓');
        await refreshCart(true);
      } catch (err) {
        showToast('No se pudo añadir. Vuelve a intentarlo.', true);
        console.error(err);
      } finally {
        if (submit) { submit.disabled = false; submit.textContent = submit.dataset.orig || 'Añadir al carrito'; }
      }
    });
  }

  /* ── Lightbox de la imagen principal ── */
  const mainImgWrap = $('.k-buy__main');
  if (mainImgWrap) {
    mainImgWrap.addEventListener('click', (e) => {
      const img = e.target.closest('img');
      if (!img) return;
      openLightbox(img.src, img.alt || '');
    });
    mainImgWrap.style.cursor = 'zoom-in';
  }

  function openLightbox(src, alt) {
    let lb = $('.k-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'k-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Imagen ampliada');
      lb.innerHTML = '<button class="k-lightbox__close" type="button" aria-label="Cerrar">✕</button><img alt="">';
      document.body.appendChild(lb);
      lb.addEventListener('click', (e) => {
        if (e.target === lb || e.target.classList.contains('k-lightbox__close')) closeLightbox();
      });
    }
    const img = lb.querySelector('img');
    img.src = src;
    img.alt = alt;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lb.querySelector('.k-lightbox__close').focus();
  }
  function closeLightbox() {
    const lb = $('.k-lightbox');
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

  /* ── Cart bounce ── */
  function bounceCart() {
    const icon = $('.k-cart-icon');
    if (!icon || reducedMotion) return;
    icon.classList.remove('is-bouncing');
    void icon.offsetWidth;
    icon.classList.add('is-bouncing');
  }

  /* ── Toast ── */
  let toastTimer = null;
  function showToast(msg, isError) {
    let t = $('.k-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'k-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ── Cart drawer ── */
  const drawer = $('.k-drawer');
  const drawerBackdrop = $('.k-drawer-backdrop');
  const drawerClose = $('.k-drawer__close');
  const drawerBody = $('.k-drawer__body');
  const drawerSubtotal = $('[data-drawer-subtotal]');
  const cartIcon = $('.k-cart-icon');
  const cartCount = $('.k-cart-icon__count');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = $('.k-drawer__close', drawer);
    if (closeBtn) setTimeout(() => closeBtn.focus(), 100);
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  if (cartIcon) cartIcon.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); refreshCart(); });
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  async function refreshCart(shouldOpen) {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      if (cartCount) {
        if (cart.item_count > 0) { cartCount.textContent = cart.item_count; cartCount.hidden = false; }
        else { cartCount.hidden = true; }
      }
      if (shouldOpen) openDrawer();
    } catch (err) { console.error(err); }
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML =
        '<div class="k-drawer__empty">' +
        '<svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color:var(--k-primary);margin:0 auto 1rem;opacity:0.5;"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M6 6L4 2H2"/></svg>' +
        '<h3>Tu carrito está vacío</h3>' +
        '<p>Añade el cortaúñas eléctrico Kalma para empezar.</p>' +
        '<a class="k-btn k-btn--primary" href="/">Seguir comprando</a>' +
        '</div>';
      if (drawerSubtotal) drawerSubtotal.textContent = '';
      const foot = $('.k-drawer__foot');
      if (foot) foot.style.display = 'none';
      return;
    }
    const foot = $('.k-drawer__foot');
    if (foot) foot.style.display = '';

    const items = cart.items.map((item) => {
      const img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">' : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="k-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return (
        '<div class="k-cart-item" data-key="' + item.key + '">' +
          '<div class="k-cart-item__img">' + img + '</div>' +
          '<div>' +
            '<p class="k-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
            variant +
            '<div class="k-cart-item__actions">' +
              '<div class="k-qty k-qty--sm">' +
                '<button type="button" data-cart-minus aria-label="Menos">−</button>' +
                '<input type="text" value="' + item.quantity + '" data-cart-qty inputmode="numeric" aria-label="Cantidad">' +
                '<button type="button" data-cart-plus aria-label="Más">+</button>' +
              '</div>' +
              '<button type="button" class="k-cart-item__remove" data-cart-remove aria-label="Eliminar">Eliminar</button>' +
            '</div>' +
          '</div>' +
          '<div class="k-cart-item__price">' + moneyEs(item.line_price) + '</div>' +
        '</div>'
      );
    }).join('');
    drawerBody.innerHTML = items;
    if (drawerSubtotal) drawerSubtotal.textContent = moneyEs(cart.total_price);

    $$('.k-cart-item', drawerBody).forEach((row) => {
      const key = row.dataset.key;
      const qtyInp = $('[data-cart-qty]', row);
      const minus = $('[data-cart-minus]', row);
      const plus = $('[data-cart-plus]', row);
      const rm = $('[data-cart-remove]', row);
      const changeQty = (delta, newVal) => {
        const target = typeof newVal === 'number' ? Math.max(0, newVal) : Math.max(0, (parseInt(qtyInp.value, 10) || 0) + delta);
        updateLine(key, target);
      };
      if (minus) minus.addEventListener('click', () => changeQty(-1));
      if (plus) plus.addEventListener('click', () => changeQty(1));
      if (rm) rm.addEventListener('click', () => updateLine(key, 0));
      if (qtyInp) qtyInp.addEventListener('change', () => changeQty(0, parseInt(qtyInp.value, 10) || 0));
    });
  }

  async function updateLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      renderCart(cart);
      if (cartCount) {
        if (cart.item_count > 0) { cartCount.textContent = cart.item_count; cartCount.hidden = false; }
        else { cartCount.hidden = true; }
      }
    } catch (err) { console.error(err); }
  }

  /* ── Sticky buy bar en móvil (para product template) ── */
  const stickyBar = $('.k-sticky-buy');
  const anchorBuy = $('#buy');
  if (stickyBar && anchorBuy && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' });
    obs.observe(anchorBuy);
  }

  // Refresh on load
  refreshCart(false);
})();
